import React from "react";
import { Clock, Layers, Briefcase, ShieldCheck, Award, PlayCircle, Sparkles } from "lucide-react";
import { COURSE_META, ELEARNING_COURSE_URL } from "@/data/certificationProgramData";

const STATS = [
  { icon: Clock, label: "8 Weeks", sub: "Live + Recorded Cohort" },
  { icon: Briefcase, label: "5 Live Projects", sub: "Real Industry Use-Cases" },
  { icon: Layers, label: "12 Modules", sub: "Complete Data Cloud Syllabus" },
  { icon: ShieldCheck, label: "Certification Ready", sub: "Exam Prep Included" },
];

export function InternshipHero({ onEnquiry }) {
  return (
    <div className="text-center mb-10" data-testid="internship-hero">
      <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-amber-300 bg-amber-400/10 border border-amber-400/30 rounded-full px-3 py-1">
        Data Cloud Certification Program · 8 Weeks
      </span>
      <h1 className="font-heading text-3xl sm:text-5xl font-semibold text-white mt-5 leading-tight">
        Master Salesforce Data Cloud. <span className="text-amber-300">Build the Customer 360 Companies Need.</span>
      </h1>
      <p className="text-sm sm:text-base text-slate-400 mt-4 max-w-2xl mx-auto">
        An 8-week, E-Learning IT-delivered, mentor-led program built around 5 real enterprise projects — identity
        resolution, segmentation, activation and AI-powered personalization. Walk out with a job-ready portfolio,
        not just a certificate.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
        <a href={ELEARNING_COURSE_URL} target="_blank" rel="noreferrer" data-testid="certification-enroll-now-button" className="flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-white font-bold text-sm px-6 py-3 rounded-xl transition-colors">
          <Award className="w-4 h-4" /> Enroll Now — ₹{COURSE_META.price.toLocaleString("en-IN")}
        </a>
        <a href={ELEARNING_COURSE_URL} target="_blank" rel="noreferrer" data-testid="certification-self-paced-videos-button" className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold text-sm px-6 py-3 rounded-xl transition-colors">
          <PlayCircle className="w-4 h-4 text-amber-300" /> Self Paced Learning Videos
        </a>
        <button onClick={onEnquiry} data-testid="certification-internship-style-button" className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold text-sm px-6 py-3 rounded-xl transition-colors">
          <Sparkles className="w-4 h-4 text-amber-300" /> Learn Like an Internship
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-8" data-testid="certification-quick-facts">
        {STATS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={i} className="glass-panel rounded-xl p-4 text-center" data-testid={`certification-fact-${i}`}>
              <Icon className="w-5 h-5 text-amber-300 mx-auto mb-2" />
              <p className="text-sm font-semibold text-white">{s.label}</p>
              <p className="text-[11px] text-slate-400 mt-0.5">{s.sub}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
